
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Workorder, WorkordersApi, CostPart } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    api: 'ordersApi'
  })
})
export default class AddPurchasedPartComponent extends Vue {
  private api!: WorkordersApi;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  get orderReactive() {
    return this.order;
  }

  private popoverOpen = false;

  private cPart: CostPart = {};
  private partQuantityInput: number | null = null;

  async addPart() {
    try {
      this.cPart.partCostType = 'Purchase';
      if (!this.cPart.partUnitCost) {
        this.cPart.partUnitCost = 0;
      }
      if (this.partQuantityInput && this.partQuantityInput <= 0) {
        this.partQuantityInput = 1;
      }
      const addedPart = await this.api.addPartToOrder({
        costPartCreateCommand: {
          ...this.cPart,
          workorderId: this.order.workorderId,
          quantity: this.partQuantityInput
        }
      });
      this.$emit('partAdded', addedPart);
      this.popoverOpen = false;
      this.cPart = {};
      this.partQuantityInput = null;
    } catch (error) {
      this.$emit('error', error);
    }
  }

  cancelPart() {
    this.cPart = {};
    this.popoverOpen = false;
  }
}
